import { FINANCIAL_ADVISOR_INVITE_LINK_POST } from '../actions/types';

const initialState = {
  inviteLink: undefined,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FINANCIAL_ADVISOR_INVITE_LINK_POST._SUCCESS: {
      const { inviteLink } = action.payload;
      state.inviteLink = inviteLink;
      return state;
    }
    default:
      return state;
  }
};

export { reducer as financialAdvisor };
